import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Deal {
  id: string;
  hubspot_id: string;
  dealname: string;
  pipeline: string;
  dealstage: string;
  amount: string;
  hs_lastmodifieddate: string;
  createdate: string;
  closedate: string;
  hubspot_owner_id: string;
  referenciador: string;
  partner_id: number;
  partner_name: string;
  partner_type: string;
  company_id: string;
  company_name: string;
  synced_at: string;
  closed_lost_reason: string;
  fixed_commission: number;
  recurring_commission: number;
  total_commission: number;
  createdAt: string;
  updatedAt: string;
}

export interface ListDealsParams {
  page?: number;
  per_page?: number;
  search?: string;
  stage?: string;
  reference?: string;
  partner?: string | number;
  start_date?: string;
  end_date?: string;
  close_start_date?: string;
  close_end_date?: string;
  commission_status?: string;
  partner_type?: string;
  sort_by?:
    | 'opportunity'
    | 'company'
    | 'createdate'
    | 'amount'
    | 'status'
    | 'commission'
    | 'closedate'
    | 'referenciador'
    | 'hs_lastmodifieddate'
    | 'partner_type';
  sort_direction?: 'asc' | 'desc';
}

export interface ListDealsResponse {
  success: boolean;
  message: string;
  data?: {
    data: Deal[];
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
  errors?: { message: string }[];
}

export interface DealActivity {
  id: string;
  type: 'notes' | 'emails' | 'calls' | 'meetings';
  title: string;
  body: string | null;
  timestamp: string;
  owner_id: string;
}

export interface DealActivityResponse {
  success: boolean;
  message: string;
  data: DealActivity[];
}

@Injectable({ providedIn: 'root' })
export class PipelinesService {
  private readonly http = inject(HttpClient);

  listDeals(params?: ListDealsParams): Observable<ListDealsResponse> {
    return this.http.get<ListDealsResponse>(`${environment.apiUrl}/hubspot/pipelines/deals`, {
      params: params as Record<string, string | number | boolean>,
    });
  }

  getDealActivity(id: string): Observable<DealActivityResponse> {
    return this.http.get<DealActivityResponse>(
      `${environment.apiUrl}/hubspot/deals/${id}/activity`
    );
  }

  checkCompanyByNif(nif: string): Observable<{ success: boolean; data?: any }> {
    return this.http.get<{ success: boolean; data?: any }>(
      `${environment.apiUrl}/hubspot/companies/check-nif/${nif}`
    );
  }

  createOpportunity(data: any): Observable<{ success: boolean; message: string; data?: any }> {
    return this.http.post<{ success: boolean; message: string; data?: any }>(
      `${environment.apiUrl}/hubspot/deals`,
      data
    );
  }
}
